import React, { useState } from "react";
import dollars from "../../images/icons/dollars.svg";

const HeaderPiece = ({ text, quantity, bg, boosted }) => {
  const [showInfo, setShowInfo] = useState(false);
  return (
    <div
      style={{
        borderRadius: "6px",
        background: bg
          ? "#343434"
          : boosted
          ? "linear-gradient(92deg, #A81AFF -0.77%, #FC1C6D 100.54%)"
          : "",
      }}
      className="flex flex-col p-2 items-start relative"
    >
      <div
        style={{
          color: bg || boosted ? "#FFFFFF" : "rgba(163, 163, 163, 0.67)",
          fontFamily: "Rubik",
          fontSize: "13px",
          fontStyle: "normal",
          fontWeight: "400",
          lineHeight: "normal",
          letterSpacing: "0.26px",
          textTransform: "uppercase",
        }}
        className=""
      >
        {text}
      </div>
      <div className="flex justify-between items-center w-full relative">
        <div
          className=" flex"
          style={{
            color: "#FFF",
            textAlign: "center",
            fontFamily: "Rubik",
            fontSize: "24px",
            fontStyle: "normal",
            fontWeight: "400",
            lineHeight: "normal",
            minWidth: boosted ? "109px" : "",
          }}
        >
          {(text === "BOOSTED" ? "🚀 " : "") + quantity || 0}
        </div>
        <div className="flex items-center">
          {text === "EARNED SHROOMS" ? (
            <div className=" ">
              <img
                className=" flex absolute -top-1 right-3.5"
                src={dollars}
                alt=""
              />
            </div>
          ) : (
            ""
          )}
          {text === "EARNED SHROOMS" && (
            <div
              onMouseEnter={() => setShowInfo(true)}
              onMouseLeave={() => setShowInfo(false)}
              className="cursor-pointer pt-1"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  opacity="0.4"
                  d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
                  fill="#F0F0F0"
                />
                <path
                  d="M11.7256 13.9211C11.6477 13.9211 11.5828 13.9 11.5309 13.8577C11.479 13.807 11.453 13.7394 11.453 13.6549C11.453 13.5704 11.453 13.4859 11.453 13.4014C11.453 13.3169 11.453 13.2324 11.453 13.1479C11.4703 12.7845 11.5525 12.4634 11.6996 12.1845C11.8467 11.9056 12.0241 11.6521 12.2318 11.4239C12.4481 11.1958 12.6644 10.9803 12.8807 10.7775C13.097 10.5662 13.2787 10.3549 13.4258 10.1437C13.5816 9.93239 13.6768 9.70845 13.7114 9.47183C13.746 9.16761 13.6854 8.91408 13.5297 8.71127C13.3739 8.5 13.1619 8.33944 12.8937 8.22958C12.6255 8.11972 12.3486 8.06479 12.063 8.06479C11.6044 8.06479 11.2108 8.1831 10.882 8.41972C10.5618 8.64789 10.3498 9.03662 10.246 9.58592C10.22 9.68732 10.1768 9.75916 10.1162 9.80141C10.0556 9.84366 9.9864 9.86479 9.90853 9.86479H9.28554C9.20766 9.86479 9.13844 9.83944 9.07787 9.78873C9.02596 9.73803 9 9.67042 9 9.58592C9.00865 9.23944 9.08653 8.90986 9.23362 8.59718C9.38072 8.28451 9.58838 8.00986 9.85661 7.77324C10.1335 7.53662 10.458 7.3507 10.83 7.21549C11.2108 7.07183 11.6347 7 12.102 7C12.6298 7 13.0797 7.07183 13.4518 7.21549C13.8325 7.3507 14.1354 7.53662 14.3603 7.77324C14.5939 8.00141 14.7627 8.25493 14.8665 8.5338C14.9703 8.81268 15.0136 9.09155 14.9963 9.37042C14.9703 9.70845 14.8838 10.0127 14.7367 10.2831C14.5896 10.5451 14.4122 10.7901 14.2046 11.0183C13.9969 11.238 13.7849 11.4577 13.5686 11.6775C13.3609 11.8887 13.1792 12.1127 13.0235 12.3493C12.8764 12.5775 12.7942 12.8268 12.7769 13.0972C12.7682 13.1901 12.7596 13.2831 12.7509 13.3761C12.7509 13.4606 12.7509 13.5451 12.7509 13.6296C12.7336 13.7225 12.699 13.7944 12.6471 13.8451C12.5952 13.8958 12.5216 13.9211 12.4265 13.9211H11.7256ZM11.6218 16C11.5352 16 11.4617 15.9746 11.4011 15.9239C11.3492 15.8648 11.3232 15.793 11.3232 15.7085V14.9352C11.3232 14.8507 11.3492 14.7831 11.4011 14.7324C11.4617 14.6732 11.5352 14.6437 11.6218 14.6437H12.4654C12.5606 14.6437 12.6341 14.6732 12.686 14.7324C12.7466 14.7831 12.7769 14.8507 12.7769 14.9352V15.7085C12.7769 15.793 12.7466 15.8648 12.686 15.9239C12.6341 15.9746 12.5606 16 12.4654 16H11.6218Z"
                  fill="white"
                />
              </svg>
            </div>
          )}
        </div>
      </div>
      {showInfo ? (
        <div
          style={{
            background: "##2C271F",
            zIndex: "12",
          }}
          className="absolute top-14 -left-[90px] flex w-[430px] h-12 bg-black text-white  text-[10px] justify-center items-center  font-light tracking-wide rounded-[12px] p-4 gap-2"
        >
          <svg
            className="w-8"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M12 11C11.7348 11 11.4804 11.1054 11.2929 11.2929C11.1054 11.4804 11 11.7348 11 12V16C11 16.2652 11.1054 16.5196 11.2929 16.7071C11.4804 16.8946 11.7348 17 12 17C12.2652 17 12.5196 16.8946 12.7071 16.7071C12.8946 16.5196 13 16.2652 13 16V12C13 11.7348 12.8946 11.4804 12.7071 11.2929C12.5196 11.1054 12.2652 11 12 11ZM12.38 7.08C12.1365 6.97998 11.8635 6.97998 11.62 7.08C11.4973 7.12759 11.3851 7.19896 11.29 7.29C11.2017 7.3872 11.1306 7.49882 11.08 7.62C11.024 7.73868 10.9966 7.86882 11 8C10.9992 8.13161 11.0245 8.26207 11.0742 8.38391C11.124 8.50574 11.1973 8.61656 11.29 8.71C11.3872 8.79833 11.4988 8.86936 11.62 8.92C11.7715 8.98224 11.936 9.00632 12.099 8.99011C12.2619 8.97391 12.4184 8.91792 12.5547 8.82707C12.691 8.73622 12.8029 8.61328 12.8805 8.46907C12.9582 8.32486 12.9992 8.16378 13 8C12.9963 7.73523 12.8927 7.48163 12.71 7.29C12.6149 7.19896 12.5028 7.12759 12.38 7.08ZM12 2C10.0222 2 8.08879 2.58649 6.4443 3.6853C4.79981 4.78412 3.51809 6.3459 2.76121 8.17317C2.00433 10.0004 1.8063 12.0111 2.19215 13.9509C2.578 15.8907 3.53041 17.6725 4.92894 19.0711C6.32746 20.4696 8.10929 21.422 10.0491 21.8079C11.9889 22.1937 13.9996 21.9957 15.8268 21.2388C17.6541 20.4819 19.2159 19.2002 20.3147 17.5557C21.4135 15.9112 22 13.9778 22 12C22 10.6868 21.7413 9.38642 21.2388 8.17317C20.7363 6.95991 19.9997 5.85752 19.0711 4.92893C18.1425 4.00035 17.0401 3.26375 15.8268 2.7612C14.6136 2.25866 13.3132 2 12 2ZM12 20C10.4178 20 8.87104 19.5308 7.55544 18.6518C6.23985 17.7727 5.21447 16.5233 4.60897 15.0615C4.00347 13.5997 3.84504 11.9911 4.15372 10.4393C4.4624 8.88743 5.22433 7.46197 6.34315 6.34315C7.46197 5.22433 8.88743 4.4624 10.4393 4.15372C11.9911 3.84504 13.5997 4.00346 15.0615 4.60896C16.5233 5.21447 17.7727 6.23984 18.6518 7.55544C19.5308 8.87103 20 10.4177 20 12C20 14.1217 19.1572 16.1566 17.6569 17.6569C16.1566 19.1571 14.1217 20 12 20Z"
              fill="#FFC062"
            />
          </svg>
          <span className="text-[#FFE3B8] text-[12px] font-inter ">
            MUSHBOOMERS EARN SHROOMS EVERYDAY IF THEY ARE UNLISTED
          </span>
        </div>
      ) : (
        ""
      )}
    </div>
  );
};

export default HeaderPiece;
